import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.map";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 注册、登录、注销
 * */
import util from '@/libs/util';
import router from '@/router';
import Setting from '@/setting';
import { AccountRegister, GetTicket } from '@api/account';
// import { cloneDeep } from 'lodash';
import { Modal } from 'view-design';
var userName = '';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var dispatch = _ref.dispatch;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$username = _ref2.username,
        username = _ref2$username === void 0 ? '' : _ref2$username,
        _ref2$password = _ref2.password,
        password = _ref2$password === void 0 ? '' : _ref2$password,
        _ref2$brandName = _ref2.brandName,
        brandName = _ref2$brandName === void 0 ? '' : _ref2$brandName;
      return new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                userName = username;
                // 开始请求登录接口
                _context2.next = 3;
                return GetTicket({
                  // TenantId: 1,
                  abb: brandName,
                  LoginId: username,
                  Secret: password,
                  Type: 20
                }).then(/*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (res.extra) {
                            res.extra = JSON.parse(res.extra);
                          }
                          _context.next = 3;
                          return dispatch('setInitUserTicket', res);
                        case 3:
                          // 结束
                          resolve();
                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  reject(err);
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    setInitUserTicket: function () {
      var _setInitUserTicket = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, result) {
        var commit, dispatch, expire, extra, now, ticket, Name, Roles, Stores, TenantId, TenantName, UserId, createdAt, expireAt, tokenInfo, RoleTypes, roleType, userInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit, dispatch = _ref5.dispatch;
              expire = result.expire, extra = result.extra, now = result.now, ticket = result.ticket; // 角色信息
              if (!extra) {
                _context3.next = 20;
                break;
              }
              Name = extra.Name, Roles = extra.Roles, Stores = extra.Stores, TenantId = extra.TenantId, TenantName = extra.TenantName, UserId = extra.UserId;
              createdAt = new Date(now).getTime();
              expireAt = createdAt + expire * 1000; // 完整的登录信息
              tokenInfo = _objectSpread(_objectSpread({}, result), {}, {
                extra: extra,
                expireAt: expireAt
              }); // 用户信息
              RoleTypes = Roles.map(function (item) {
                return item.RoleType;
              }); // 所有权限类型集合
              roleType = ''; // 主权限类型（最大权限）
              if (RoleTypes && RoleTypes.length) {
                if (RoleTypes.includes('ALL')) {
                  roleType = 'ALL';
                } else if (RoleTypes.includes('STORE')) {
                  roleType = 'STORE';
                } else {
                  roleType = RoleTypes[0];
                }
              }
              userInfo = Object.assign(result, {
                uuid: 'streffy-admin-uuid' + UserId,
                info: {
                  userName: userName,
                  name: Name,
                  id: UserId,
                  avatar: 'https://dev-file.iviewui.com/userinfoPDvn9gKWYihR24SpgC319vXY8qniCqj4/avatar',
                  access: RoleTypes,
                  // 账号-权限信息
                  stores: Stores,
                  // 账号-绑定的门店
                  roleType: roleType,
                  // 角色类型
                  roles: Roles // 角色集合
                }
              }); // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天，可在 setting.js 中修改
              // 如果你的 token 不是通过 cookie 携带，而是普通字段，也可视情况存储在 localStorage
              util.cookies.set('token', ticket, {}, true);
              util.cookies.set('tokenInfo', JSON.stringify(tokenInfo), {}, true);
              util.cookies.set('uuid', userInfo.uuid);

              // 品牌信息
              _context3.next = 16;
              return dispatch('admin/brandInfo/set', {
                label: TenantName,
                value: TenantId,
                tenantId: TenantId
              }, {
                root: true
              });
            case 16:
              _context3.next = 18;
              return dispatch('admin/user/set', userInfo.info, {
                root: true
              });
            case 18:
              _context3.next = 20;
              return dispatch('load', {
                loadOpenedTabs: Setting.page.loadOpenedTabs
              });
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function setInitUserTicket(_x4, _x5) {
        return _setInitUserTicket.apply(this, arguments);
      }
      return setInitUserTicket;
    }(),
    /**
     * @description 获取登录token
     * @param {Object} param TenantId {String} TenantId
     * @param {Object} param LoginId {String} 用户账号
     * @param {Object} param Secret {String} 密码
     * */
    getTicket: function getTicket(_ref6) {
      var _ref6$TenantId = _ref6.TenantId,
        TenantId = _ref6$TenantId === void 0 ? '' : _ref6$TenantId,
        _ref6$LoginId = _ref6.LoginId,
        LoginId = _ref6$LoginId === void 0 ? '' : _ref6$LoginId,
        _ref6$Secret = _ref6.Secret,
        Secret = _ref6$Secret === void 0 ? '' : _ref6$Secret;
      return new Promise(/*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve, reject) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return GetTicket({
                  // TenantId: 1,
                  LoginId: LoginId,
                  Secret: Secret,
                  Type: 20
                }).then(/*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(res) {
                    var createdAt, expireAt, tokenInfo;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (res) {
                            createdAt = new Date(res.now).getTime();
                            expireAt = createdAt + res.expire * 1000;
                            tokenInfo = _objectSpread(_objectSpread({}, res), {}, {
                              expireAt: expireAt
                            });
                            util.cookies.set('token', res.ticket, {}, true);
                            util.cookies.set('tokenInfo', JSON.stringify(tokenInfo), {}, true);
                          }
                          // 结束
                          resolve();
                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x8) {
                    return _ref8.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  reject(err);
                });
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x6, _x7) {
          return _ref7.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 退出登录
     * */
    logout: function logout(_ref9) {
      var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
      var _ref0 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref0$confirm = _ref0.confirm,
        confirm = _ref0$confirm === void 0 ? false : _ref0$confirm,
        vm = _ref0.vm;
      function logout() {
        return _logout.apply(this, arguments);
      }
      function _logout() {
        _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                // 删除cookie
                util.cookies.remove('token');
                window.localStorage.removeItem('treeToken');
                util.cookies.remove('tokenInfo');
                util.cookies.remove('uuid');
                // 清空 vuex 用户信息
                _context6.next = 6;
                return dispatch('admin/user/set', {}, {
                  root: true
                });
              case 6:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 7:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        Modal.confirm({
          title: vm.$t('basicLayout.logout.confirmTitle'),
          content: vm.$t('basicLayout.logout.confirmContent'),
          onOk: function onOk() {
            logout();
          }
        });
      } else {
        logout();
      }
    },
    /**
     * @description 注册
     * @param {Object} param context
     * @param {Object} param mail {String} 邮箱
     * @param {Object} param password {String} 密码
     * @param {Object} param mobile {String} 手机号码
     * @param {Object} param captcha {String} 验证码
     */
    register: function register(_ref1) {
      var dispatch = _ref1.dispatch;
      var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref10$mail = _ref10.mail,
        mail = _ref10$mail === void 0 ? '' : _ref10$mail,
        _ref10$password = _ref10.password,
        password = _ref10$password === void 0 ? '' : _ref10$password,
        _ref10$mobile = _ref10.mobile,
        mobile = _ref10$mobile === void 0 ? '' : _ref10$mobile,
        _ref10$captcha = _ref10.captcha,
        captcha = _ref10$captcha === void 0 ? '' : _ref10$captcha;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountRegister({
          mail: mail,
          password: password,
          mobile: mobile,
          captcha: captcha
        }).then(/*#__PURE__*/function () {
          var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(res) {
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  // 注册成功后，完成与登录一致的操作
                  // 注册也可视情况不返还 uuid、token 等数据，在注册完成后，由前端自动执行一次登录逻辑
                  util.cookies.set('uuid', res.uuid);
                  // util.cookies.set('token', res.token);
                  // 设置 vuex 用户信息
                  _context7.next = 3;
                  return dispatch('admin/user/set', res.info, {
                    root: true
                  });
                case 3:
                  _context7.next = 5;
                  return dispatch('load');
                case 5:
                  // 结束
                  resolve();
                case 6:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
          return function (_x9) {
            return _ref11.apply(this, arguments);
          };
        }()).catch(function (err) {
          reject(err);
        });
      });
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {Object} loadOpenedTabs 是否加载页签信息
     */
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref12) {
        var state,
          dispatch,
          _ref13,
          _ref13$loadOpenedTabs,
          loadOpenedTabs,
          _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              state = _ref12.state, dispatch = _ref12.dispatch;
              _ref13 = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {}, _ref13$loadOpenedTabs = _ref13.loadOpenedTabs, loadOpenedTabs = _ref13$loadOpenedTabs === void 0 ? true : _ref13$loadOpenedTabs;
              return _context9.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resolve) {
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return dispatch('admin/user/load', null, {
                          root: true
                        });
                      case 2:
                        _context8.next = 4;
                        return dispatch('admin/page/openedLoad', {
                          loadOpenedTabs: loadOpenedTabs
                        }, {
                          root: true
                        });
                      case 4:
                        _context8.next = 6;
                        return dispatch('admin/menu/getHeaderMenu', null, {
                          root: true
                        });
                      case 6:
                        // end
                        resolve();
                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x1) {
                  return _ref14.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function load(_x0) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }
};